import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import theme from './theme';

// Layout Components
import Navbar from './components/Layout/Navbar';
import Footer from './components/Layout/Footer';
import FloatingActionButtons from './components/Layout/FloatingActionButtons';
import ScrollToTop from './components/ScrollToTop';
import InquiryPopup from './components/InquiryPopup';

// Public Pages
import Home from './pages/Home';
import About from './pages/About';
import Tours from './pages/Tours';
import Services from './pages/Services';
import CorporateBooking from './pages/CorporateBooking';
import WildLifeTours from './pages/WildLifeTours';
import Contact from './pages/Contact';
import BookingPage from './pages/BookingPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import ExclusiveOffersPage from './pages/ExclusiveOffersPage';

// Shared layout wrapper for public pages
const PublicLayout = () => {
  const [popupOpen, setPopupOpen] = useState(false);

  const handleOpenInquiry = () => {
    setPopupOpen(true);
  };

  const handlePopupClose = () => {
    setPopupOpen(false);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navbar />
      <Box component="main" sx={{ flexGrow: 1 }}>
        <Outlet />
      </Box>
      <Footer />
      <FloatingActionButtons onOpenInquiry={handleOpenInquiry} />
      <InquiryPopup open={popupOpen} onClose={handlePopupClose} />
    </Box>
  );
};

const App = () => {
  useEffect(() => {
    document.title = process.env.REACT_APP_LOGO_TEXT || 'Sam Holidays';
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <ScrollToTop />
        <Routes>
          {/* Public Routes with Navbar and Footer */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/tours" element={<Tours />} />
            <Route path="/services" element={<Services />} />
            <Route path="/corporate-booking" element={<CorporateBooking />} />
            <Route path="/wildlife-tours" element={<WildLifeTours />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/booking" element={<BookingPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
            <Route path="/exclusive-offers" element={<ExclusiveOffersPage />} />
          </Route>
        </Routes>
      </Router>
    </ThemeProvider>
  );
};

export default App;